import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_69a84848: FaireBrandEntity = {
  token: "b_69a84848",
  type: "brand",
  name: "Amano Studio",
  avatarUrl:
    "https://cdn.faire.com/fastly/f4ebdf1290da593a0f8843aa3a88647b70e359721861ac46d69c2b91c0c14ef5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e55d6d8a827710078becc5497e564a452a8593c2cd39080e379e77f207a72916.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f4ebdf1290da593a0f8843aa3a88647b70e359721861ac46d69c2b91c0c14ef5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e55d6d8a827710078becc5497e564a452a8593c2cd39080e379e77f207a72916.jpeg",
  location: "Sonoma, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 630,
  isTopShop: true,
  isInsider: true,
  description:
    'Amano Studio is a small, woman owned jewelry brand and zero waste production studio based in Sonoma California.  Founder and designer, Seana Pedelaborde, is a 28 year veteran of the fashion and gift market.   Amano Studio is an affordable line of fashion jewelry with an emphasis on quality materials, on-trend design and five star customer service.  \n\nAmano Studio designs are made with domestically produced and imported parts.  We partner with a handful of old New England workshops that give us access to archives of 70+ years of molds and tooling which allows us to resuscitate genuine vintage design as those designs cycle back into fashion.  This is one of the most fun and interesting parts of our work!  We also salvage "dead stock" vintage from East Coast factories that have closed.  We also work with a small workshop in Seoul South Korea that makes our Miyuki Japanese Seed Bead collection.  Visit our retail website to find out more: amanostudiojewelry.com\n\nWe draw creative inspiration from vintage fashion, the night sky and the beauty of the California landscape.\n\n\n\n',
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:01.717Z",
    importedBy: "entity-db-cli",
  },
};
